import { z } from "zod";

import type { ProductCategoriesParams } from "@/features/onboarding/models";
import { Category } from "@/shared/domains";
import { parseResponseData, privateAPI, publicAPI } from "@/shared/lib";
import type { ServiceResponse } from "@/shared/lib/axios";
import { productGroupSchema, productSchema } from "../models";
import type { Product } from "../models";

export const getProductCategories = async (params: ProductCategoriesParams) => {
  const response = await publicAPI.get("/product-categories", { params });

  return parseResponseData(
    response,
    z.array(Category.extend({ disabledByState: z.boolean() })),
  );
};

export const getPatientCategories = async () => {
  const response = await privateAPI.get("patients/product-categories");

  return parseResponseData(response, z.array(Category));
};

export interface GetProductsByCategoryParams {
  categorySlug: Category["slug"];
  higherValue?: boolean;
  slug?: string;
  frequency?: number;
  priceVariant?: string;
  couponCode?: string;
}

export const getProductsByCategory = async ({
  categorySlug,
  ...params
}: GetProductsByCategoryParams) => {
  const response = await publicAPI.get(
    `/product-categories/${categorySlug}/products`,
    { params },
  );

  return parseResponseData(response, productGroupSchema.array());
};

export const getPatientProductsByCategory = async (id: Category["id"]) => {
  const { data } = await privateAPI.get<ServiceResponse<Product[]>>(
    `patients/product-categories/${id}/products`,
  );

  return z.array(productSchema).parse(data.data);
};
